import { Button, Group, Modal, Stack, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useState } from 'react';
import { X } from 'tabler-icons-react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { ErrorResponse } from '../../type/error-response.types';
import { UpdateSettlementStatusToPendingRequest } from '../../type/update-settlement-status-request.type';

interface Props {
  isPendingSettlementModalOpen: boolean;
  setIsPendingSettlementModalOpen: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  settlementId: number;
  setRefreshTable: React.Dispatch<React.SetStateAction<boolean>>;
}
function PendingSettlementModal(props: Props) {
  const axiosPrivate = useAxiosPrivate();
  const {
    isPendingSettlementModalOpen,
    setIsPendingSettlementModalOpen,
    settlementId,
    setRefreshTable,
  } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setIsPendingSettlementModalOpen(false);
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      const request: UpdateSettlementStatusToPendingRequest = {
        settlementId: settlementId,
      };

      await axiosPrivate.put('web/settlements/status/pending', request);
      setRefreshTable((prev) => !prev);
      handleClose();
    } catch (err: any) {
      const error: ErrorResponse = err.response?.data;

      showNotification({
        id: 'failed-to-update-settlement-status',
        message:
          error?.error ||
          err?.response?.data?.error ||
          'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        size='xl'
        opened={isPendingSettlementModalOpen}
        centered
        onClose={handleClose}
        closeOnClickOutside={isLoading ? false : true}
        closeOnEscape={isLoading ? false : true}
      >
        <Stack p='xl'>
          <Group>
            <Title>Set Payout To Pending</Title>
          </Group>

          <form onSubmit={handleSubmit}>
            <Group mt={8} grow>
              <Button onClick={handleSubmit} fullWidth loading={isLoading}>
                Confirm
              </Button>
            </Group>
          </form>
        </Stack>
      </Modal>
    </>
  );
}

export default PendingSettlementModal;
